// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3sUl_","name":"Header_name__YiQ_Y","birthday":"Header_birthday__17fkT","skeleton":"Header_skeleton__1HsB-"};